module.exports = __webpack_public_path__ + "img/logo-cn.ec404879.svg";